























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class SectionKie extends Vue {
  @Prop({ required: true }) value!: any[];
  local: any[] = [];

  materiMap: { [k: string]: string } = {
    seribu_nifas: "Senam Nifas",
    breast_care: "Breast Care",
    asi: "ASI",
    perawatan_tali_pusat: "Perawatan Tali Pusat",
    kl: "Keluarga Berencana",
    gizi: "Gizi",
    imunisasi: "Imunisasi"
  };

  mounted() {
    this.local = JSON.parse(JSON.stringify(this.value || []));
  }

  materiLabel(key: string) {
    return this.materiMap[key] || key;
  }

  @Watch("local", { deep: true })
  emitInput(v: any[]) {
    this.$emit("input", v);
  }
}
